import {analytics} from 'src/config/firebase.config';
import { logEvent } from "firebase/analytics";

export enum AnalyticsEvent {
    CREATE_MATCH = 'create_match_clicked',
    OPEN_MATCH_PLAYERS = 'open_match_players',
    OPEN_PLAYER_CHAT = 'open_player_chat',
    OPEN_GROUP_CHAT = 'open_group_chat',
    OPEN_CUSTOMER_CHAT = 'open_customer_chat',
    SEND_CHAT_MESSAGE = 'send_chat_message',
    OPEN_CHAT_INBOX = 'open_chat_inbox',
}

const useAnalytics = () => {
    const trackEvent = (eventName: AnalyticsEvent, eventData: Record<string, any>) => {
        logEvent(analytics, eventName, eventData);
    };

    return {
        trackEvent,
    };
};

export default useAnalytics;